import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Autosuggest from 'react-autosuggest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputGroup, Input, InputGroupText } from 'reactstrap';

class Autocomplete extends Component {
    constructor() {
        super();
        // Autosuggest is a controlled component.
        // This means that you need to provide an input value
        // and an onChange handler that updates this value (see below).
        // Suggestions also need to be provided to the Autosuggest,
        // and they are initially empty because the Autosuggest is closed.
        this.state = {
            value: '',
            suggestions: [],
            isFetching: false,
        };
    }

    // componentDidMount(prevProps, prevState) {
    //     this.onSuggestionsFetchRequested(this.state);
    // }

    onChange = (event, { newValue, method }) => {
        this.setState({
            value: newValue,
        }, () => {
            setTimeout(() => {
                if(newValue.length > 1 && this.state.value === newValue) {
                    this.setState({
                        isFetching: !!this.props.onChange,
                    });
                    this.props.onChange && this.props.onChange(newValue, method).then(() => {
                        this.setState({
                            isFetching: false,
                        });
                        setTimeout(() => this.onSuggestionsFetchRequested(this.state), 200);
                    });
                }
            }, 400);
        });
    };

    // Autosuggest will call this function every time you need to update suggestions.
    onSuggestionsFetchRequested = ({ value }) => {
        console.log('onSuggestionsFetchRequested');
        this.setState({
            suggestions: (this.props.items || []).filter(item => (this.props.shouldItemRender ? this.props.shouldItemRender(item, value) : item?.text?.toLowerCase().includes(value?.toLowerCase()))),
        });
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        console.log('onSuggestionsClearRequested');
        this.setState({
            suggestions: [],
        });
    };

    render() {
        const inputProps = {
            ...(this.props.inputProps || {}),
            value: this.state.value || (this.props.inputProps || {}).value || '',
            onChange: this.onChange,
        };

        return (
            <div className="position-relative">
                <Autosuggest
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => { this.setState({ value: '' }); this.props.onSelect(suggestion); }}
                    getSuggestionValue={this.props.getItemValue || (suggestion => suggestion?.text)}
                    renderSuggestion={this.props.renderItem}
                    inputProps={inputProps}
                    renderInputComponent={inputProps => (
                        <InputGroup>
                            {this.props.renderExtraInputGroupBefore && this.props.renderExtraInputGroupBefore(this.state.value)}
                            <InputGroupText><FontAwesomeIcon icon={this.state.isFetching ? 'spinner' : 'search'} spin={this.state.isFetching} /></InputGroupText>
                            <Input {...inputProps} />
                            {this.props.renderExtraInputGroupAfter && this.props.renderExtraInputGroupAfter(this.state.value)}
                        </InputGroup>
                    )}
                    // renderSuggestionsContainer={({ containerProps, children, query }) => (
                    //     <div
                    //         {...containerProps}
                    //     >
                    //         {children}
                    //     </div>
                    // )}
                />
            </div>
        );
    }
}

Autocomplete.defaultProps = {
    items: [],
    inputProps: {},
    onChange: null,
};

Autocomplete.propTypes = {
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    getItemValue: PropTypes.func,
    renderItem: PropTypes.func.isRequired,
    shouldItemRender: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.object),
    inputProps: PropTypes.object,
    renderExtraInputGroupBefore: PropTypes.func,
    renderExtraInputGroupAfter: PropTypes.func,
};

export default Autocomplete;
